module.exports = __webpack_public_path__ + "static/media/ev-page-screenshot.38b08cc6.png";